// Permanent redirect — customer questions and decline reasons live inside
// «Голос клиента» (#843, #844; спека 2026-10-02-customer-questions-and-decline-reasons.md
// §4, §8 п. 9), not on a page of their own: the Sales tab's Questions section
// (#2060) — frequent questions and questions without an answer; declines are
// the next section. The section's own gate decides what the visitor sees
// there: without the questions flag the tab falls back to Objections.
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/analytics/customer-questions')({
  beforeLoad: () => {
    throw redirect({
      to: '/analytics/voice',
      search: { voiceSection: 'questions' },
      replace: true,
    });
  },
});
